import { render, staticRenderFns } from "./ListMoreSkills.vue?vue&type=template&id=198e90b6&scoped=true&"
import script from "./ListMoreSkills.vue?vue&type=script&lang=js&"
export * from "./ListMoreSkills.vue?vue&type=script&lang=js&"
import style0 from "./ListMoreSkills.vue?vue&type=style&index=0&id=198e90b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e90b6",
  null
  
)

export default component.exports